// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39d47c7b","553":"1dbfa0cb","977":"69e54a0e"}[chunkId] + ".chunk.js";
};